import { User } from '@vendasta/iamv2';
import { UserWithDisplayName } from './tokens-and-interfaces';

export function userFilterFn(user: UserWithDisplayName, searchTerm: string): boolean {
  searchTerm = searchTerm?.toLowerCase();
  const includesFullName = user.displayName.toLowerCase().includes(searchTerm);
  const includesFirstName = user.firstName.toLowerCase().includes(searchTerm);
  const includesLastName = user.lastName.toLowerCase().includes(searchTerm);
  const includesUserId = user.userId.toLowerCase().includes(searchTerm);
  const includesEmail = user.email.toLowerCase().includes(searchTerm);
  return includesFullName || includesFirstName || includesLastName || includesUserId || includesEmail;
}

export function convertToReadableUsers(users: User[]): UserWithDisplayName[] {
  return users.map(
    (user) =>
      ({
        ...user,
        displayName: `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim() ?? user?.userId,
      } as UserWithDisplayName),
  );
}
